import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/HomePage.vue'
import Map from '../views/MapPage.vue'
import Notify from '../views/NotifyPage.vue'

const routes = [
    {
        path: '/',
        name: 'HomePage',
        component: Home
    },
    {
        path: '/mymap',
        name: 'MapPage',
        component: Map
    },
    {
        path: '/mynotify',
        name: 'NotifyPage',
        component: Notify
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

export default router
